import { render } from "./NotifyBar.vue?vue&type=template&id=046618bb&ts=true&lang=pug"
import script from "./NotifyBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotifyBar.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__